<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: 'safetyActivityInfo' }">安全活动信息表</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form :model="ruleForm" ref="ruleForm" label-width="110px"
                     class="demo-ruleForm" style="width:60%;margin:0 auto"
                     size="small" :rules="rules"
            >
                <el-form-item label="活动标题" prop="activitieName">
                    <el-input v-model="ruleForm.activitieName" placeholder="活动标题"/>
                </el-form-item>
                <el-form-item label="活动日期" prop="activitieTime">
                    <el-date-picker
                            v-model="ruleForm.activitieTime"
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="活动地点" prop="activitiePlace">
                    <el-input v-model="ruleForm.activitiePlace" placeholder="活动地点"/>
                </el-form-item>
                <el-form-item label="活动主持人" prop="compere">
                    <el-input v-model="ruleForm.compere" placeholder="活动主持人"/>
                </el-form-item>
                <el-form-item label="主办部门" prop="hostDep">
                    <el-select v-model="ruleForm.hostDep" style="width: 100%">
                        <el-option v-for="item in depList" :key="item.id" :value="item.name" :label="item.name"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="主要参与人员" prop="coreTeamEmpIds">
                    <el-select v-model="ruleForm.coreTeamEmpIds" style="width: 100%" multiple>
                        <el-option v-for="item2 in staffList" :key="item2.id" :value="item2.id" :label="item2.name"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否发布" prop="isIssue">
                    <el-radio-group v-model="ruleForm.isIssue" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="活动内容">
                    <el-input v-model="ruleForm.activitieContent" type="textarea" :rows="3" placeholder="活动内容"/>
                </el-form-item>
                <el-form-item label="活动情况与总结">
                    <el-input v-model="ruleForm.activitieSummary" type="textarea" :rows="3"
                              placeholder="活动情况与总结"/>
                </el-form-item>
                <el-form-item label="附件">
                    <el-upload
                            class="upload-demo"
                            action="/v1/trainMaterials/uploadFile"
                            :on-remove="handleRemove"
                            multiple
                            :limit="1"
                            :on-change="handleChange"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="" style="margin-top: 40px">
                    <el-button style="width: 100%" type="primary" @click="submit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {getAllDepartment, safetyActivityInfoAdd, getStaffList, safetyActivityInfoEdit} from '@/api/processManager'

    export default {
        name: 'AddSafetyActivity',
        data() {
            return {
                ruleForm: {},
                rules: {
                    activitieName: [{required: true, message: '请输入活动标题'}],
                    activitieTime: [{required: true, message: '请选择'}],
                    activitiePlace: [{required: true, message: '请输入活动地点'}],
                    compere: [{required: true, message: '请输入活动主持人'}],
                    hostDep: [{required: true, message: '请选择'}],
                    coreTeamEmpIds: [{required: true, message: '请选择主要参与人员', trigger: 'blur'}],
                    isIssue: [{required: true, message: '是否发布'}]
                },
                fileList: [],
                depList: [],
                staffList: [],
            }
        },
        created() {
            console.log(this.$route.params.key)
            this.getAllDep();
            this.getStaff();
            if (this.$route.params.key) {
                this.ruleForm = this.$route.params.key
                if (this.ruleForm.fileUrl) {
                    this.fileList.push(
                        {name: this.ruleForm.fileName, response: {data: this.ruleForm.fileUrl}}
                    )
                }
            }
        },
        methods: {
            // 获取部门
            getAllDep() {
                getAllDepartment().then(res => {
                    this.depList = res.body.data
                })
            },
            // 获取员工
            getStaff() {
                getStaffList().then(res => {
                    this.staffList = res.body.data
                })
            },
            // 上传的事件
            handleChange(file, fileList) {
                this.fileList = fileList
            },
            handleRemove(file, fileList) {
                this.fileList = fileList
            },
            handleExceed(files, fileList) {
                this.$message.warning(`限制上传一个文件`);
            },
            // 提交表单
            submit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        let obj = {...this.ruleForm}
                        if (this.fileList.length > 0) {
                            obj.fileUrl = this.fileList[0].response.data
                            obj.fileName = this.fileList[0].name
                        }
                        let arr = []
                        for (let i in obj.coreTeamEmpIds) {
                            for (let j in this.staffList) {
                                if (obj.coreTeamEmpIds[i] === this.staffList[j].id) {
                                    arr.push(this.staffList[j].name)
                                }
                            }
                        }
                        let str = obj.coreTeamEmpIds.join(',')
                        obj.coreTeamEmpIds = str
                        obj.coreTeamEmpNames = arr.join(',')
                        // 编辑
                        if (this.$route.params.key) {
                            safetyActivityInfoEdit({...obj}).then(res => {
                                this.$message.success('编辑成功');
                                this.$router.push('safetyActivityInfo')
                            })
                        }
                        // 新增
                        else {
                            safetyActivityInfoAdd({...obj}).then(res => {
                                this.$message.success('添加成功');
                                this.$router.push('safetyActivityInfo')
                            })
                        }
                    } else {
                        return false;
                    }
                });
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    }
</script>

<style scoped>

</style>
